<div class="sub-container">
   
    <h2 class="headline-highlight">Add Payment Method</h2>
   
    <div class="hosted-payment-container">
      <h3>Add Credit Card</h3>
      <div class="iframe-placeholder">
        <div *ngIf="loading" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
          <p>Loading Authorize.Net Payment Form...</p>
        </div>
        <div *ngIf="systemError" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); color: red;">
          <p>Error loading payment form. Please try again.</p>
        </div>
        <iframe
          #addPaymentIframe  
          id="add_payment"
          style="width: 100%; height: 100%; border: none; visibility: hidden;"  name="authorizeNetIframe"
        ></iframe>
      </div>

    </div> 

 </div>